import { apiClient } from "./apiClient";


export const searchApi = {
    Search: (request: any) => apiClient.post(`ts_hocsinh/search`,request),

}